import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=10f168b5&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=js&"
export * from "./Timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f168b5",
  null
  
)

export default component.exports